/* istanbul ignore file */
import React from 'react'
import interceptedAxios from '../../../utils/interceptedAxios'

export class viewAssetService {
  public static async viewAsset (assetId: string): Promise<any> {
    const AssetListUrl = `/assetrest/api/v2/udp/tiq/assets/${assetId}`
    return await interceptedAxios.get(AssetListUrl)
  }

  render (): any {
    return (
      <></>
    )
  }
}
